/* CONSTANTS */
import { DEFAULT_PER_PAGE } from '@/api/constants';
/* STORES */
import { useAuthStore } from '@/stores/auth';
/* TYPES */
import type { Company } from '@/types/company/company.types';
import type { DevPlanStatus } from '@/types/devPlans/devPlans.types';

import ViktorClient from '../../clients/viktorClient/ViktorClient';
import type { CompanyDevPlansParams } from './company.types';

/**
 * Get data about current user's company
 */
export function getCompany(uuid): Promise<Company> {
  const params = {
    is_greenhouse_client: 1,
    fields:'dynamic_reports'
  };
  return ViktorClient().get(`/company/${uuid}`, { params });
}

/**
 * Get employees list for the recruiter's company
 */
export function getEmployeesListForCompany({ page, searchTerm, extraParam, order }) {
  const companyUuid = useAuthStore().getCompany.uuid;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let params: any = {
    per_page: DEFAULT_PER_PAGE,
    page
  };

  if (searchTerm) {
    params['search[user_data.slug_full_name]'] = searchTerm;
  }

  if (order) {
    params.order = order;
  }

  if (extraParam) {
    params = { ...params, ...extraParam };
  }

  return ViktorClient().get(`/company/${companyUuid}/employees`, { params });
}
/**
 * Get dev plans for the company
 */
export function getCompanyDevPlans({
  page,
  order,
  status = ['in_progress', 'completed', 'awaiting_science'],
  usersUUID
}: {
  page: number;
  order: string;
  status: DevPlanStatus[];
  usersUUID: string[];
}) {
  const companyUuid = useAuthStore().getCompany.uuid;

  const params: CompanyDevPlansParams = {
    per_page: DEFAULT_PER_PAGE,
    page,
    order,
    status
  };

  if (usersUUID.length) {
    params['user:uuid'] = usersUUID;
  }

  return ViktorClient().get(`/company/${companyUuid}/dev-plans`, { params });
}
/**
 * Get employee associated to at least a dev plans
 */
export function getCompanyDevPlansEmployees({ page, searchTerm }) {
  const companyUuid = useAuthStore().getCompany.uuid;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const params: any = {
    per_page: DEFAULT_PER_PAGE,
    page
  };

  if (searchTerm) {
    params['search[user_data.slug_full_name]'] = searchTerm;
  }

  return ViktorClient().get(`/company/${companyUuid}/dev-plan/employees`, { params });
}
